export const colors = ['#3C486B', '#F9D949', '#569DAA', '#41644A', '#E86A33', '#393646', '#D14D72', '#77037B', '#7AA874', '#000000', '#DFA67B']